import { InsalesProduct, InsalesService } from '../api';

class InsalesProductData {
  public id?: number;
  public product?: InsalesProduct;
}

interface InsalesProductsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: InsalesProduct[]; total: number }>;
  //   create: (resource: string, params: any) => Promise<{ data: Insales }>;
  getOne: (
    resource: string,
    params: any
  ) => Promise<{ data: InsalesProductData }>;
  //   update: (resource: string, params: any) => Promise<{ data: Insales }>;
  getMany: (
    resource: string,
    params: any
  ) => Promise<{ data: InsalesProduct[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: InsalesProduct[] }>;
}

export const insalesProductsProvider: InsalesProductsProviderResource = {
  getList: async (resource, params) => {
    console.log('getList');
    console.log(resource);
    console.log(params);
    const { filter } = params;
    const { products, total } =
      await InsalesService.getInsalesProductsByInsalesId(filter.id);
    console.log(products);
    if (!products) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: products,
      total: total,
    };
  },
  getOne: async (resource, params) => {
    console.log('getOne ins pr prr');
    console.log(resource);
    console.log(params);
    const {
      id,
      meta: { product_id },
    } = params;
    const product = await InsalesService.getInsalesProductsById(id, product_id);
    let data = new InsalesProductData();
    data.id = id;
    data.product = product;
    console.log(product);
    return { data: data };
  },
  getMany: async (resource, params) => {
    console.log(resource);
    console.log(params);
    // const ids = params.ids;
    // console.log(ids);
    // const data: InsalesProduct[] = [];
    // for (const id of ids) {
    //   const pr = await InsalesService.getInsalesProductsById(params.id, id);
    //   data.push(pr);
    // }
    return { data: [] };
  },
  getManyReference: async (resource, params) => {
    console.log(resource);
    console.log(params);
    return { data: [] };
  },
};
